import * as React from 'react';

export const LogicJumpContext = React.createContext(null);
